import React from 'react';

const Member = ({ member, small }) => {
    const className = [
        'member',
        small && 'member-small',
        member.link && 'member-link',
    ].filter(Boolean).join(' ');

    const content = (
        <React.Fragment>
            <img
                src={member.img}
                alt={member.name}
                width={80}
                height={80}
                loading="lazy"
                decoding="async"
            />
            <div className="member-text">
                {member.name && <h3>{member.name}</h3>}
                {member.description && <p>{member.description}</p>}
            </div>
        </React.Fragment>
    );

    // If a link is provided, the whole card is the anchor
    if (member.link) {
        return (
            <a className={className} href={member.link} target="_blank" rel="noreferrer">
                {content}
            </a>
        );
    }
    return <div className={className}>{content}</div>;
};

export default Member;
